import { render, staticRenderFns } from "./FunctionManagement.vue?vue&type=template&id=036fe222&scoped=true"
import script from "./FunctionManagement.vue?vue&type=script&lang=js"
export * from "./FunctionManagement.vue?vue&type=script&lang=js"
import style0 from "./FunctionManagement.vue?vue&type=style&index=0&id=036fe222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036fe222",
  null
  
)

export default component.exports